"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _H = _interopRequireDefault(require("./../H2"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var YearbookIcon = _styledComponents["default"].i(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-right: 2px;\n  font-size: 15px;\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.warning;
});
var H2WithYearbookIcon = function H2WithYearbookIcon(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement(_H["default"], null, /*#__PURE__*/_react["default"].createElement(YearbookIcon, {
    className: "icon icon-yearbooks"
  }), children);
};
var _default = exports["default"] = H2WithYearbookIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/abihome-components/build/components/Headings/components/H2WithYearbookIcon/index.js
// module id = 349
// module chunks = 17